import React from 'react'
import { Desc, Head2 } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'
import { ExplainersCon } from './styles'

export const GoalieSkills: React.FC = () => {
  return (
    <ExplainersCon>
      <Head2 textColor={colors.gray.gray20} vertMargins={2}>
        {'Rules'}
      </Head2>
      <ul>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Two goalies face off, each defending their net set 15 yards apart`}</Desc>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`They must stay on their half, shoot from at least 12 yards out, and have 6 seconds to release the ball`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`45-second clock runs per round`}</Desc>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`If tied, sudden victory overtime decides the winner`}</Desc>
        </li>
      </ul>
      <Head2 textColor={colors.gray.gray20} vertMargins={2}>{`Former Winners`}</Head2>
      <ul>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2024: Tim Troutner`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2023: Blaze Riorden`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2022: Kyle Bernlohr`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2021: Kyle Bernlohr`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2019: Tim Troutner`}</Desc>
        </li>
      </ul>
    </ExplainersCon>
  )
}
